import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TheCage} from "../TheCage";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FreesSpinIntro} from "../runnerpresentations/FreesSpinIntro";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {FreesSpinLevelUp} from "../runnerpresentations/freespin/FreeSpinLevelUp";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheCageFreeSpinIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController:FlowStateController):void {
        const presentations:SimplePresentation[] = [
            new FreesSpinIntro(),
            new FreesSpinLevelUp(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.doFreeSpinZeroBet(controller), ()=>{return true}, "doFreeSpinZeroBet")
        ];

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "Fs intro runner ");

    }

    private doFreeSpinZeroBet(controller:SimplePresentationRunnerController) {
        TheCage.apiPlugin.betHandler.zeroBet();
        TheCage.keypadPlugin.setZeroBetSpinCounter(TheCage.model.data.freespinsLeft-1);
        TheCage.freeSpinReelView.playerCounter.tickDown(1);
        controller.finish();
    }
}